export default __webpack_public_path__ + "static/media/pre_step1.097311fc.png";